import { MutableRefObject, useState } from 'react';
import { CellProps } from 'react-table';
import { ConfirmDialog } from '../../../../../component/ConfirmDialog';
import CustomIconButton from '../../../../../component/custom-icon-button/CustomIconButton';
import { TableCustomHeader } from '../../../../../component/table/components/TableCustomHeader';
import { TableCustom } from '../../../../../component/table/table-custom/TableCustom';
import { ThuocColumns } from '../../../../components/modal-tab-thuoc/ThuocColumns';
import { getPriceByObjectType } from '../../utils';

type Props = {
	tableData: any[];
	categories: any;
	rowSelectedRef: MutableRefObject<any>;
	onEditDrug: (drug: any) => void;
	onDeleteDrug: () => void;
	updateRowData: (rowIndex: number, field: string, value: any) => void;
};

const IndicationTable = ({
	tableData,
	categories,
	rowSelectedRef,
	onEditDrug,
	updateRowData,
	onDeleteDrug,
}: Props) => {
	const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

	const columnsActions = {
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thao tác"
				className="text-center text-light min-w-80px"
			/>
		),
		id: 'actions',
		Cell: ({ row }: CellProps<any>) => {
			return (
				<div className="d-flex justify-content-center">
					<CustomIconButton
						variant="edit"
						onClick={() => {
							onEditDrug(row.original);
						}}
					>
						<i className="bi bi-pencil-square text-navy"></i>
					</CustomIconButton>
					<CustomIconButton
						variant="delete"
						onClick={() => {
							rowSelectedRef.current = row.original;
							setOpenConfirmDelete(true);
						}}
					>
						<i className="bi bi-trash3-fill text-danger"></i>
					</CustomIconButton>
				</div>
			);
		},
	};

	return (
		<div className="spaces h-calc-vh-470 bg-white spaces py-10 px-0 radius-2 mt-6 table-ke-thuoc">
			<TableCustom
				data={tableData}
				columns={ThuocColumns}
				maxHeight={300}
				columnsActions={columnsActions}
				tableOptions={{
					updateRowData,
					objectTypes: categories?.listDoiTuong,
					getPriceByObjectType,
				}}
			/>

			{openConfirmDelete && (
				<ConfirmDialog
					className="z-index-1060"
					show={openConfirmDelete}
					title="Thông báo"
					message="Bạn có chắc chắn muốn xóa thuốc này không ?"
					yes="Xác nhận"
					close="Đóng"
					onCloseClick={() => {
						setOpenConfirmDelete(false);
						rowSelectedRef.current = null;
					}}
					onYesClick={() => {
						setOpenConfirmDelete(false);
						onDeleteDrug();
					}}
				/>
			)}
		</div>
	);
};

export default IndicationTable;
